import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, of, switchMap } from 'rxjs';
import { environment } from './../../environments/environment';
import { ProcessedTrainingProgression, TrainingProgressionMapper } from '@app/mappers/training-progression.mapper';

@Injectable({
  providedIn: 'root',
})
export class TrainingProgressionService {
  constructor(
    private http: HttpClient,
    private trainingProgressionMapper: TrainingProgressionMapper
  ) {}

  fetchTrainingProgression(): Promise<ProcessedTrainingProgression | null> {
    const url: string = `${environment.token_auth_config.apiBase}/v3/training_progression`;

    return lastValueFrom(
      this.http.get(url).pipe(
        switchMap((data: any) => {
          if (data) {
            return of(this.trainingProgressionMapper.mapTrainingProgressionData(data));
          }
          return of(null);
        })
      )
    );
  }
}
